import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import '../../../assets/css/BloomLanding.css';
import Logo from "../../../assets/images/bloom.png";
import bloomintro from '../../../assets/images/bloom_video.mp4';

const BloomLandingPage = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const videoContainerRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (videoRef.current) {
          if (entry.isIntersecting) {
            // Reset video to start and play when in view
            videoRef.current.currentTime = 0;
            videoRef.current.play().catch((err) =>
              console.warn("Video play error:", err)
            );
          } else {
            // Pause and reset video when out of view
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
          }
        }
      },
      {
        threshold: 0.3,
      }
    );

    if (videoContainerRef.current) {
      observer.observe(videoContainerRef.current);
    }

    return () => {
      if (videoContainerRef.current) {
        observer.unobserve(videoContainerRef.current);
      }
    };
  }, []);

  const handleContactClick = (e) => {
    e.preventDefault();
    navigate("/bloom");
    setTimeout(() => {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      } else {
        console.warn("Contact section not found after navigation.");
      }
    }, 100);
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div className="bloom-container">
      {/* Navbar */}
      <nav className="bloom-navbar">
        <div className="bloom-logo">
          <Link to="/">
            <img src={Logo} alt="Bloom Logo" className="bloom-logo-image" />
          </Link>
        </div>
        <div className="bloom-nav-links">
          <Link to="/">Home</Link>
          <Link onClick={handleContactClick}>Contact Us</Link>
        </div>
      </nav>

      {/* Video Section */}
      <div className="bloom-video-section" ref={videoContainerRef}>
        <video
          ref={videoRef}
          className="bloom-fullscreen-video"
          src={bloomintro}
          loop
          playsInline
          muted={isMuted}
        >
          Your browser does not support the video tag.
        </video>
        <div className="video-controls">
          <button
            onClick={toggleMute}
            className="video-control-btn"
            aria-label={isMuted ? "Unmute video" : "Mute video"}
          >
            {isMuted ? "🔇" : "🔊"}
          </button>
        </div>
      </div>

      {/* Innovation Banner */}
      <section className="innovation-banner">
        <h2 className="banner-title">Dignity, Comfort & Style for Your Healing Journey</h2>
        <p className="banner-subtitle">
          A personalized clothing solution for women undergoing mastectomy.
        </p>
      </section>

      {/* Footer */}
      <div className="bloom-footer">
        {/* Add footer content if needed */}
      </div>
    </div>
  );
};

export default BloomLandingPage;